module.exports = __webpack_public_path__ + "static/roboto-regular-48506d6785f6308d99658391062a5dc0.woff2";